import * as actions from './actions';
import * as reducers from './reducers';

const middleware = () => next => action => next(action);

export { middleware, actions, reducers };
